import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Sheet = ApplicationRecord.extend({
  static: {
    jsonapiType: 'sheets',
  },
  attrs: {
    index: attr(),
    customerData: attr(),
    hasDownloadableImage: attr(),
    foregroundId: attr(),
    imageTypeValue: attr({ persist: false }),
    backgroundId: attr(),
    imageTypeId: attr(),
    orderPackageId: attr(),
    seniorImageId: attr(),
    poseId: attr(),
    studentImageId: attr(),
    background: belongsTo(),
    imageType: belongsTo(),
    orderPackage: belongsTo(),
    pose: belongsTo(),
    seniorImage: belongsTo(),
    studentImage: belongsTo(),
    foreground: belongsTo(),
  },
})

export default Sheet
